module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av434-20847bcf0de7878892afac74747c7db4.jpg";